export const ACTIONS = {
  SET_NEWS: "SET_NEWS",
  ADD_BOOKMARK: "ADD_BOOKMARK",
  REMOVE_BOOKMARK: "REMOVE_BOOKMARK",
  SET_SORT: "SET_SORT",
};
